var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-1"},[_c('ICountUp',{attrs:{"delay":_vm.delay,"endVal":_vm.endVal,"options":_vm.options},on:{"ready":_vm.onReady}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }